// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   title: '',
//   logo: '../assets/images/unimicro-x-logo-white.png',
//   navbar_color: '',
//   navbar_text_color: '',
// };

export const environment = {
  production: true,
  title: 'SB1 Infokanal',
  logo: '../assets/images/sb1-logo.png',
  navbar_color: '#fff',
  navbar_text_color: 'black',
};
